import React, { useEffect, useState } from "react";
import { getTTSEvent } from "../../../../apis/TTS/event.api";
import useForm from "../../../../hooks/useForm";
import { Breadcrumbs, Grid, Typography } from "@mui/material";
import {
  getTTSContextAvailByEventId,
  getTTSContextDetail,
} from "../../../../apis/TTS/context.api";
import {
  applyForTTSIntent,
  createTTSIntentScript,
  getTTSIntentScript,
  updateSkillNameForTTSIntent,
} from "../../../../apis/TTS/intentScript.api";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";
import {
  getTTSIntentByEventIdAndContextId,
  getTTSIntentDetail,
} from "../../../../apis/TTS/intent.api";
import { NotifyConfirm } from "../../../../components/notify/Notify";
import { useLocation } from "react-router-dom";
import IntentScriptConfig from "../../components/IntentScriptConfig/IntentScriptConfig";
import { showBreadCrumb } from "./TTSIntentConfigBackup";
import SkillConfig from "../../components/SkillConfig/SkillConfig";

const initialValue = {
  eventId: "",
  contextId: "",
  skillName: "",
};

const listEventByAction = (id, ttsEvent = null, listEvent = []) => {
  ttsEvent = !ttsEvent ? [] : [ttsEvent];
  return id ? ttsEvent : listEvent;
};

const listContextByAction = (id, ttsContext = null, listContext = []) => {
  ttsContext = !ttsContext ? [] : [ttsContext];
  return id ? ttsContext : listContext;
};

const TTSIntentConfig = () => {
  let { id } = useParams();
  const location = useLocation();

  // Parse the query parameters
  const queryParams = new URLSearchParams(location.search);
  const eventType = queryParams.get("eventType") || "success";

  // eslint-disable-next-line no-unused-vars
  const [intent, setIntent] = useState(null);
  const [listEvent, setListEvent] = useState([]);
  const [listContext, setListContext] = useState([]);
  const [listSlot, setListSlot] = useState([]);
  const [intentValues, setIntentValue] = useState(null);
  const [intentScriptValues, setIntentScriptValues] = useState("[]");

  const { values, setValues, handleInputChange } = useForm({
    ...initialValue,
  });

  useEffect(() => {
    if (id) {
      getTTSIntentDetail(id, (result) => {
        setIntent({ ...result });
        setValues((prevValues) => ({
          ...prevValues,
          eventId: result.ttsEvent?.id,
          contextId: result.ttsContext?.id,
          skillName: result.skillName,
        }));

        setIntentValue(JSON.parse(result.values));
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  // get event and context default
  useEffect(() => {
    // get tts event
    getTTSEvent({ eventType }, (result) => {
      setListEvent([...result.list]);
    });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // get available context by eventId
  useEffect(() => {
    // get tts context
    if (values.eventId) {
      getTTSContextAvailByEventId({ eventId: values.eventId }, (result) => {
        setListContext([...(result || [])]);
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [values.eventId]);

  // get intentScript by EventId and contextId
  useEffect(() => {
    if (values.contextId) {
      // get tts context
      getTTSContextDetail(values.contextId, (result) => {
        setListSlot([...(result.slots || [])]);
      });

      getTTSIntentScript(
        {
          eventId: values.eventId,
          contextId: values.contextId,
        },
        (result) => {
          if (!result) {
            setIntentScriptValues("[]");
          } else {
            setIntentScriptValues(result.values);
          }
        }
      );

      const query = {
        eventId: values.eventId,
        contextId: values.contextId,
      };
      getTTSIntentByEventIdAndContextId(query, (result) => {
        if (result) {
          setIntent({ ...result });
          setIntentValue(JSON.parse(result.values));
          setValues((prevValues) => ({
            ...prevValues,
            skillName: result.skillName,
          }));
        } else {
          setIntent(null);
          setIntentValue(null);
          setValues((prevValues) => ({
            ...prevValues,
            skillName: "",
          }));
        }
      });
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [values.contextId]);

  const handleCreateIntentScript = (listIntentValue) => {
    const intentScriptData = {
      ...values,
      type: eventType,
      values: listIntentValue,
    };

    createTTSIntentScript(intentScriptData, (result) => {
      getTTSIntentScript(
        {
          eventId: values.eventId,
          contextId: values.contextId,
        },
        (result) => {
          if (!result) {
            setIntentScriptValues("[]");
          } else {
            setIntentScriptValues(result.values);
          }
        }
      );
    });
  };

  const applyForIntent = (intentTemplate) => {
    if (values.eventId && values.contextId) {
      NotifyConfirm(
        "warning",
        "Are you want to apply template for this intent ?",
        (result) => {
          if (result.isConfirmed) {
            // call api apply
            const data = {
              eventId: values.eventId,
              contextId: values.contextId,
              skillName: values.skillName,
            };
            applyForTTSIntent(data, (_) => {
              setIntentValue(intentTemplate);
            });
          }
        }
      );
    }
  };

  const updateSkillName = (intentTemplate) => {
    if (values.eventId && values.contextId) {
      NotifyConfirm(
        "warning",
        "Are you want to change skill name?",
        (result) => {
          if (result.isConfirmed) {
            // call api apply
            const data = {
              eventId: values.eventId,
              contextId: values.contextId,
              skillName: values.skillName,
              type: eventType,
            };
            updateSkillNameForTTSIntent(data, (_) => {
              setIntentValue(intentTemplate);
            });
          }
        }
      );
    }
  };

  return (
    <div>
      <Breadcrumbs aria-label="breadcrumb">
        <Typography
          color="text.primary"
          component={"span"}
          textTransform="capitalize"
          fontWeight="bold"
        >
          {showBreadCrumb(intent, eventType)}
        </Typography>
      </Breadcrumbs>
      <div style={{ marginTop: "40px" }}>
        <Grid container>
          <Grid item xs={12} p={5} container>
            <>
              <Grid item xs={12} p={5}>
                <SkillConfig
                  values={values}
                  handleInputChange={handleInputChange}
                  listEvent={listEventByAction(id, intent?.ttsEvent, listEvent)}
                  listContext={listContextByAction(
                    id,
                    intent?.ttsContext,
                    listContext
                  )}
                  id={id}
                  updateSkillName={updateSkillName}
                  intentValues={intentValues}
                />
              </Grid>

              <Grid item xs={12} p={5}>
                {values.eventId && values.contextId ? (
                  <IntentScriptConfig
                    handleCreateIntentScript={handleCreateIntentScript}
                    contextSlots={listSlot || []}
                    intentScriptValues={intentScriptValues || "[]"}
                    applyForIntent={applyForIntent}
                  />
                ) : (
                  <h4>Chọn Event Và Context Để Tiếp Tục</h4>
                )}
              </Grid>
            </>
          </Grid>
        </Grid>
      </div>
    </div>
  );
};

export default TTSIntentConfig;
